import Vue from "vue";
import SvgIcon from "vue-svgicon";

//config as described here https://mmf-fe.github.io/svgicon/en/
Vue.use(SvgIcon, {
  tagName: "svgIcon",
  defaultWidth: "2rem",
  defaultHeight: "2rem"
});
